import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface CalendarClockIconProps extends SvgIconProps {}

export const CalendarClockIcon = (props: CalendarClockIconProps): ReactElement => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <mask
      id="mask0_991_10393"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_991_10393)">
      <path
        d="M5 9.61504H19V6.61529C19 6.46129 18.9359 6.32021 18.8077 6.19204C18.6796 6.06388 18.5385 5.99979 18.3845 5.99979H5.6155C5.4615 5.99979 5.32042 6.06388 5.19225 6.19204C5.06408 6.32021 5 6.46129 5 6.61529V9.61504ZM5.6155 20.9998C5.15517 20.9998 4.77083 20.8456 4.4625 20.5373C4.15417 20.229 4 19.8446 4 19.3843V6.61529C4 6.15496 4.15417 5.77063 4.4625 5.46229C4.77083 5.15396 5.15517 4.99979 5.6155 4.99979H7.3845V2.76904H8.4615V4.99979H15.6155V2.76904H16.6155V4.99979H18.3845C18.8448 4.99979 19.2292 5.15396 19.5375 5.46229C19.8458 5.77063 20 6.15496 20 6.61529V11.867C19.8372 11.8069 19.6724 11.762 19.5057 11.7325C19.3391 11.703 19.1705 11.6761 19 11.6518V10.6153H5V19.3843C5 19.5383 5.06408 19.6794 5.19225 19.8075C5.32042 19.9357 5.4615 19.9998 5.6155 19.9998H12.3193C12.3717 20.187 12.4388 20.3607 12.5203 20.521C12.6016 20.6812 12.6865 20.8408 12.775 20.9998H5.6155ZM18.3845 21.9998C17.2705 21.9998 16.3253 21.6116 15.549 20.8353C14.7727 20.0591 14.3845 19.114 14.3845 17.9998C14.3845 16.8856 14.7727 15.9405 15.549 15.1643C16.3253 14.388 17.2705 13.9998 18.3845 13.9998C19.4987 13.9998 20.4439 14.388 21.2203 15.1643C21.9964 15.9405 22.3845 16.8856 22.3845 17.9998C22.3845 19.114 21.9964 20.0591 21.2203 20.8353C20.4439 21.6116 19.4987 21.9998 18.3845 21.9998ZM20.0405 20.2018L20.5865 19.6555L18.7693 17.8383V15.1153H18V18.1613L20.0405 20.2018Z"
        fill="currentColor"
      />
    </g>
  </SvgIcon>
);
